import VueSelect from './VueSelect';
export default VueSelect;
